import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M25.4001 3.76807C25.4001 3.76807 20.1201 1.45801 13.7401 1.45801C7.36008 1.45801 2.08008 3.76807 2.08008 3.76807C6.81008 5.47807 11.8001 5.578 13.5801 5.578C15.3601 5.578 20.6701 5.47807 25.4001 3.76807Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M5.97998 5.1781L12.8 1.6582L9.05998 5.39819" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M21.5002 5.1781L14.6802 1.6582L18.4202 5.39819"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
